// libs
import styled from 'styled-components'

export const ChipsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  .MuiChip-root {
    width: auto;
    min-width: unset;
    height: 24px;
    font-size: 12px;
    box-shadow:
      rgba(0, 0, 0, 0.2) 0px 1px 3px 0px,
      rgba(0, 0, 0, 0.14) 0px 1px 1px 0px,
      rgba(0, 0, 0, 0.12) 0px 0px 0px 0px;
  }

  .MuiChip-label {
    padding: 0 8px;
  }

  .MuiChip-icon {
    width: 14px;
    height: 14px;
    margin-left: 6px;
  }
`

// Read-only progress slider + its value. Colours follow `currentColor` so the slider stays visible
// on root rows too (their cells invert to white text on the plan colour).
export const ProgressWrapper = styled.div`
  display: flex;
  gap: 8px;
  min-width: 92px;
  align-items: center;

  .MuiSlider-root {
    padding: 0;
    height: 4px;
    color: currentColor;
    pointer-events: none;
  }

  .MuiSlider-rail {
    opacity: 0.3;
  }

  // No handle — the cell shows progress, it does not set it.
  .MuiSlider-thumb {
    display: none;
  }
`

export const ProgressValue = styled.span`
  font-size: 12px;
  font-weight: bold;
`

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;

  .MuiAvatar-root {
    width: 28px;
    height: 28px;
    font-size: 13px;
  }
`
